import React, { useState, useEffect } from "react";
import check from "../../assets/Images/check.png";

import "./SubscriptionManagement.css"; // Import your CSS file for animations
import { useAsaSession } from '../../services/AsaSessionServices'
import {
  useActiveSubscriptions,  useFintechLayouts } from '../../services/AsaApiServices'

import {  useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  AnalyticsService,
  AnalyticsAction,
  AnalyticsFeature,
} from "../../services/AnalyticsService";

const PaymentDone = () => {
  const { t } = useTranslation();
  
  const [isPaymentUpdate, setisPaymentUpdate] = useState(false);
  const { data: session } = useAsaSession();
  const [displayText, setDisplayText] = useState(""); // Initially empty
  const [animateDone, setAnimateDone] = useState(false); // State for animation
  const [showMessage, setShowMessage] = useState(false); // State to control message visibility
  const [doneTextDisappear, setDoneTextDisappear] = useState(false); // State to track if "DONE" text has disappeared
  const layout = useFintechLayouts();
  const { data: activesubscriptions } = useActiveSubscriptions();
  const activeSubscription = activesubscriptions ? activesubscriptions[0] : undefined;
  const location = useLocation();
  const { state } = location;
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  const handleLinkAccountClick = () => {
    const targetPage = session?.sessionPages?.find((page) => page.pageNumber === 0);
    if (targetPage) {
      const pageData = JSON.parse(targetPage.pageData);
      const successDynamicLink = pageData.successDynamicLink;
      const new_url = new URL(`${successDynamicLink}`);
      new_url.searchParams.append("statusMessage", state?.msg);
      new_url.searchParams.append("statusCode", state?.status?.toString());
      window.location.href = new_url.toString();
    }
  };

  useEffect(() => {


    const closeWindow = () => {
      window.close();
    };

    AnalyticsService.track(
      "Payment Done Viewed",
      AnalyticsAction.View,
      AnalyticsFeature.Payment,
    );

    setTimeout(() => {
      setDisplayText(t("done")); // Display "DONE" after delay
      setAnimateDone(true); // Trigger animation
    }, 0);

    setTimeout(() => {
      setDoneTextDisappear(true); // Trigger to move circle down and hide "DONE" text
    }, 2000);

    setTimeout(() => {
      setShowMessage(true); // Show message
    }, 4500);


    if (isIOS) {
      setTimeout(() => {
        handleLinkAccountClick();
      }, 6000);

      setTimeout(() => {
        closeWindow();
      }, 7000);
    }
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-[#705AE2] to-[#705AE2]"
      style={layout?.backGroundStyleFullScreen}
    >
      <div className="text-center w-full px-[20px]">
        {doneTextDisappear ? null : (
          <p className="text-center font-poppins font-medium text-white leading-8 mt-8">
            {displayText}
          </p>
        )}
        <div className={`circle-container mt-5 ${doneTextDisappear ? "move-down" : ""}`}>
          <div className={`circle ${animateDone ? "zoom-in" : ""}`}>
            <img src={check} className="" alt={t("successIconAlt")} />
          </div>
        </div>
        {showMessage && (
          <>
            <h1 className="text-white font-poppins font-bold text-[20px] leading-[32px] mt-10">
              {activeSubscription?.subscriptionTitle}
            </h1>
            <p className="text-white font-poppins animated-text mt-2">
              {isPaymentUpdate ? t("paymentUpdated") : t("paymentAdded")}
            </p>
            {!isIOS && (
              <button
                onClick={handleLinkAccountClick}
                className="mt-6 px-[20px] h-[44pt] w-full bg-white text-[#705AE2] text-[14pt] font-poppins font-bold uppercase rounded-lg shadow-lg flex items-center justify-center"
              >
                {t("done")}
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentDone;
